
<template>
    <div class="xing-zheng">
        <div class="xing-zheng-top">
            <!-- 背景图 -->
            <div class="bid-inner">
                <div class="bid-title">
                    行政服务平台数智化解决方案
                </div>
                <div class="bid-bg"></div>
            </div>
        </div>

        <div class="qi-cont">
            <div class="qi-cont-top">
                <div class="inner">
                    <p class="title">{{bidText.title}}</p>
                    <p>{{bidText.p1}}</p>
                    <p>{{bidText.p2}}</p>
                    <img src="/images/products/xing-zheng/xz-1.png" alt="">
                </div>
            </div>

            <div class="qi-cont-bot">
                <div class="inner">
                    <div class="mini-box">
                        <div class="title">公共服务平台</div>
                        <p>
                            按照河北省委、省政府要求以及《电子招标投标办法》和省《关于贯彻实施《电子招标投标办法》的工作方案》有关精神，省发改委建立全省统一、终端覆盖各设区市、县（市）的“河北省招标投标公共服务平台”。该平台由我公司负责研发。
                        </p>
                        <p class="mini-box-p">主要功能作用：</p>

                        <div class="mini-box-bot">
                            <div class="left">
                                <div class="left-item" v-for="(item,i) in ggdata" :key="i">
                                    {{item}}
                                </div>
                            </div>
                            <div class="right">
                                <img src="/images/products/xing-zheng/xz-2.png" alt="">
                            </div>
                        </div>
                    </div>

                    <div class="mini-box">
                        <div class="title">行政监督平台</div>
                        <p>
                            2017年6月，我公司负责研发和运维的河北省招标投标行政监督平台建成并上线运行，河北省的省、市、县三级发改、住建、交通、水利等共500多个监管部门的工作开始由线下转为线上，实现了在线备案、监管，2018年获得国家公共资源交易创新奖。
                        </p>
                        <div class="mini-box-bot">
                            <img src="/images/products/xing-zheng/xz-3.png" alt="">
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="qi-bot">
            <div class="qi-bot-top">
                <p class="title">系统核心八大功能</p>
                <p>全省统一的公共资源电子行政监管平台</p>
                <div class="top-list inner">
                    <div class="top-item" v-for="(item,i) in xtdata" :key="i">
                        <div class="item-box">
                            <img :src="item.img" alt="">
                            <p>{{item.text}}</p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="qi-bot-bot">
                <div class="bot-list">
                    <div class="bot-item " v-for="(item,i) in tdata" :key="i">
                        <p>{{item.text}}</p>
                        <img :src="item.img" alt="">
                    </div>
                </div>

            </div>
        </div>

    </div>
</template>

<script>
import CONFIG_PROJECT from '@config/project';
	
export default {
    head: {
        title: `产品和服务·${CONFIG_PROJECT.title}`,
    },
    name: '',
    data() {
        return {
            bidText: {
                title: '行政服务平台数智化解决方案',
                p1: '按照国家顶层制度设计，河北省电子招标投标体系由电子交易平台、公共服务平台和行政监督平台三大部分组成。其中，公共服务平台是整个体系的中心枢纽，行政监督平台是支撑各级行政监管部门履行监管职责的在线系统工具，交易平台则市场主体完成全部招标投标活动的载体。从属性上来说，公共服务平台和行政监督平台属于政务服务属性，电子交易平台则属于电子商务属性。因此，前者由政府部门建设，后者则以市场化方式提供。',
            },
            ggdata: [
                '按照统一技术标准联接分散独立的各个专业交易平台，整合链接各级人民政府及其部门平台网站信息，实现招标投标交易信息和相关行政许可监管信息的集中动态交互共享。',
                '为行政监督部门、市场主体和社会公众动态观察、综合监督和调控招标投标交易市场秩序提供集中公开和定向交互招标投标交易信息的服务。',
                '为招标投标市场提供各类交易项目发布，以及交易主体身份资格、业绩和信用的注册验证、查询和发布共享服务，有效促进市场主体诚信自律。',
                '通过对公共服务平台的大数据分析，观察市场现状及动态，预判行政调控监督政策措施的可行性及可靠性提供依据。',
            ],
            xtdata: [
                { img: '/images/products/xing-zheng/xz-m-1.png', text: '招标方案核准' },
                { img: '/images/products/xing-zheng/xz-m-2.png', text: '违法行为记录公告' },
                { img: '/images/products/xing-zheng/xz-m-3.png', text: '全程线上监管' },
                { img: '/images/products/xing-zheng/xz-m-4.png', text: '大数据' },
                { img: '/images/products/xing-zheng/xz-m-5.png', text: '实时监控' },
                { img: '/images/products/xing-zheng/xz-m-6.png', text: '专家管理' },
                { img: '/images/products/xing-zheng/xz-m-7.png', text: '投诉处理' },
                { img: '/images/products/xing-zheng/xz-m-8.png', text: '基础信息库' },
            ],
            tdata: [
                { img: '/images/products/xing-zheng/xz-4.png', text: '监管平台架构图' },
                { img: '/images/products/xing-zheng/xz-5.png', text: '平台特点' },
            ],
        };
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped>
.xing-zheng {
    background-color: #fff;
    width: 100%;
    min-height: 1000px;
    position: relative;
    .xing-zheng-top {
        z-index: 0;
        width: 100%;
        height: 360px;
        background: url('/images/products/erji-bg.png') no-repeat;
        background-size: 100% 100%;
        background-size: cover;

        .bid-inner {
            width: 1200px;
            height: 120px;
            margin: 0 auto;
            position: relative;
            .bid-title {
                width: 630px;
                color: #fff;
                font-weight: bold;
                font-size: 38px;
                position: absolute;
                top: 85px;
                left: 0;
            }
            .bid-bg {
                z-index: 10;
                position: absolute;
                top: 60px;
                right: 50px;
                width: 370px;
                height: 227px;
                background: url('/images/products/xing-zheng/bg.png') no-repeat;
                background-size: 100% 100%;
                background-size: cover;
            }
        }
    }

    .qi-cont {
        .qi-cont-top {
            padding: 30px 0;
            width: 100%;
            background-color: #f6fbfe;
            text-align: center;
            p {
                // font-weight: bold;
                font-size: 15px;
                color: #131415;
                margin: 30px 0;
                text-align: center;
            }
            .title {
                font-size: 24px;
                font-weight: bold;
                color: #131415;
            }
            img {
                margin: 30px 0;
            }
        }

        .qi-cont-bot {
            margin-top: 40px;
            padding-bottom: 30px;
            background: url('/images/products/xing-zheng/xz-bg.png') no-repeat;
            background-position: center bottom;
            .mini-box {
                margin-bottom: 50px;
                .title {
                    font-size: 22px;
                    text-align: center;
                    font-weight: bold;
                }
                p {
                    font-size: 18px;
                    // font-weight: bold;
                    margin: 20px 0;
                }
                .mini-box-p {
                    margin-top: 30px;
                }
                .mini-box-bot {
                    display: flex;
                    justify-content: space-between;
                    .left {
                        .left-item {
                            width: 580px;
                            height: 110px;
                            background-color: #f8f8f9;
                            margin-bottom: 20px;
                            padding: 20px;
                            font-size: 18px;
                            &:nth-last-child(1) {
                                margin-bottom: 0;
                            }
                        }
                    }
                    .right {
                        background-color: #fff;
                        display: flex;
                        align-items: center;
                    }
                    //两个图片 放大
                    img {
                        margin: 10px auto;
                        transition: all 0.3s;
                        cursor: pointer;
                        &:hover{
                            transform: scale(1.07);
                        }
                    }
                }
            }
        }
    }

    .qi-bot {
        // height: 360px;
        width: 100%;
        // background-color: ;
        .qi-bot-top {
            height: 350px;
            background: url('/images/products/xing-zheng/xz-m-bg.png') no-repeat;
            background-position: center;
            background-color: #264b98;
            margin-bottom: 140px;
            p {
                color: #fff;
                text-align: center;
                font-size: 16px;
            }
            .title {
                font-size: 24px;
                font-weight: bold;
                padding-top: 20px;
                margin-bottom: 30px;
            }
            .top-list {
                width: 1200px;
                height: 300px;
                position: relative;
                top: 40px;
                display: flex;
                justify-content: space-between;
                flex-wrap: wrap;
                background-color: #fff;
                box-shadow: 0 0 5px rgb(173, 173, 173);
                .top-item {
                    width: 300px;
                    height: 150px;
                    border-right: 1px solid #d8d8d8;
                    border-bottom: 1px solid #d8d8d8;
                    .item-box {
                        width: 100%;
                        height: 100%;
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        align-items: center;
                        cursor: pointer;
                        transition: all 0.3s;
                        &:hover {
                            transform: scale(1.1);
                        }
                        p {
                            color: #131415;
                            margin-top: 20px;
                            font-weight: bold;
                        }
                    }

                    //去除其他边框
                    &:nth-child(4n) {
                        border-right: none;
                    }
                    &:nth-child(n + 5) {
                        border-bottom: none;
                    }
                }
            }
        }

        .qi-bot-bot {
            height: 635px;
            background: url('/images/products/xing-zheng/xz-bg.png') no-repeat;
            background-color: #f6fafd;
            background-position: top center;
            .bot-list {
                width: 1200px;
                margin: 0 auto;
                display: flex;
                justify-content: space-between;
                .bot-item {
                    width: 580px;
                    text-align: center;
                }
                p {
                    font-size: 24px;
                    font-weight: bold;
                    margin: 30px 0;
                }
            }
        }
    }

    .inner {
        width: 1200px;
        margin: 0 auto;
    }
}
</style>
